import axios from 'axios'
import {CategoryModel, ResponseCRUD, ResponseObject, ResponseObjectPaginated} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getCategory(dto: CategoryModel, page: number) {
  return axios.post<ResponseObjectPaginated<CategoryModel[]>>(
    `${BASEURL}/Category/getAll/${page}`,
    dto,
  )
}

export function getCategoryById(dto: any) {
  return axios.get<ResponseObject<CategoryModel>>(
    `${BASEURL}/Category/getInformationById?id=${dto}`,
  )
}

export function createCategory(dto: CategoryModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/Category/createCategory`, dto)
}

export function deleteCategory(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/Category/deleteCategory?id=${dto}`)
}

export function updateCategory(dto: CategoryModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/Category/updateCategory`, dto)
}
